const bankArr =[
  {name:"招商银行股份有限公司",background:"#D95757",imgSrc:"/bankIcon/zhaoshang.png"},
  {name:"花旗银行(中国)有限公司",background:"#D95757",imgSrc:"/bankIcon/huaqi.png"},
  {name:"南京银行股份有限公司",background:"#D95757",imgSrc:"/bankIcon/nanjing.png"},
  {name:"汇丰银行(中国)有限公司上海分行",background:"#D95757",imgSrc:"/bankIcon/huifeng.png"},
  {name:"中信银行股份有限公司",background:"#D95757",imgSrc:"/bankIcon/zhongxin.png"},
  {name:"北京银行",background:"#D95757",imgSrc:"/bankIcon/beijing.png"},
  {name:"浙商银行",background:"#D95757",imgSrc:"/bankIcon/zheshang.png"},
  {name:"哈尔滨银行结算中心",background:"#D95757",imgSrc:"/bankIcon/haerbing.png"},
  {name:"徽商银行股份有限公司",background:"#D95757",imgSrc:"/bankIcon/huishang.png"},
  {name:"华夏银行股份有限公司总行",background:"#D95757",imgSrc:"/bankIcon/huaxia.png"},
  {name:"中国银行总行",background:"#D95757",imgSrc:"/bankIcon/zhongguo.png"},
  {name:"中国工商银行",background:"#D95757",imgSrc:"/bankIcon/gongshang.png"},

  {name:"平安银行",background:"#DE7E50",imgSrc:"/bankIcon/pingan.png"},
  {name:"宁波银行股份有限公司",background:"#DE7E50",imgSrc:"/bankIcon/ningbo.png"},
  {name:"重庆银行",background:"#DE7E50",imgSrc:"/bankIcon/chongqing.png"},

  {name:"交通银行",background:"#1D59C2",imgSrc:"/bankIcon/jiaotong.png"},
  {name:"兴业银行总行",background:"#1D59C2",imgSrc:"/bankIcon/xingye.png"},
  {name:"上海浦东发展银行",background:"#1D59C2",imgSrc:"/bankIcon/pufa.png"},
  {name:"恒丰银行",background:"#1D59C2",imgSrc:"/bankIcon/hengfeng.png"},
  {name:"河北银行股份有限公司",background:"#1D59C2",imgSrc:"/bankIcon/hebei.png"},

  {name:"江苏银行股份有限公司",background:"#477DD1",imgSrc:"/bankIcon/jiangsu.png"},
  {name:"中国民生银行",background:"#477DD1",imgSrc:"/bankIcon/minsheng.png"},
  {name:"中国建设银行股份有限公司总行",background:"#477DD1",imgSrc:"/bankIcon/jianshe.png"},

  {name:"中国农业银行股份有限公司",background:"#36BF73",imgSrc:"/bankIcon/nongye.png"},
  {name:"中国邮政储蓄银行有限责任公司",background:"#36BF73",imgSrc:"/bankIcon/youzheng.png"},
  {name:"江西银行股份有限公司",background:"#36BF73",imgSrc:"/bankIcon/jiangxi.png"}
]

export default bankArr